/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum CommunityType {
    POS = 'POS',
    DEFAULT = 'DEFAULT',
    NEG = 'NEG',
}
